import { CSSProperties, useEffect, useState } from 'react';

/**
 * 保活显示：首次 visible 后**保持挂载**，只是切换 display。
 * 这样在多个面板之间切换时不会卸载重建 —— 面板内部的请求与筛选/分页状态都得以保留。
 *
 * @param style 可选，透传到外层 div（例如面板需要 `height: 100%` 才能撑满容器时传 `{ height: '100%' }`）
 */
function Visible({
  visible,
  children,
  style,
}: {
  visible: boolean;
  children: JSX.Element;
  style?: CSSProperties;
}) {
  const [visibled, setVisibled] = useState(visible);

  useEffect(() => {
    if (visible) {
      setVisibled(true);
    }
  }, [visible]);

  if (visibled) {
    return (
      <div style={{ ...style, ...(visible ? undefined : { display: 'none' }) }}>{children}</div>
    );
  }

  return <></>;
}

export default Visible;
